/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Business_TitleInputs */

const en_meta_business_title = /** @type {(inputs: Meta_Business_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening for Business - Enterprise Text to Speech Solutions`)
};

const es_meta_business_title = /** @type {(inputs: Meta_Business_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening para empresas - Soluciones empresariales de texto a voz`)
};

/**
* | output |
* | --- |
* | "Listening for Business - Enterprise Text to Speech Solutions" |
*
* @param {Meta_Business_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_business_title = /** @type {((inputs?: Meta_Business_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Business_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_business_title(inputs)
	return en_meta_business_title(inputs)
});